var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('aceEditor',{ref:"myTextEditor",attrs:{"options":_vm.options,"width":_vm.width,"height":_vm.height,"lang":_vm.lang},on:{"init":_vm.editorInit},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }